import type {StandardSchemaV1} from '@standard-schema/spec';
import type {Result} from './result';

export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export interface Validator<T> {
  readonly standardSchema: StandardSchemaV1<unknown, T>;
  validate(value: unknown): Result<T, ValidationError>;
}
